import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row shadow-md rounded-xl border border-gray-lp-1600 py-2.5 px-4 gap-2 items-center" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "w-full text-sm text-gray-lp-300" }, "Ikuti laporan kendala ini untuk mendapatkan update dan beri komentar!", -1)
const _hoisted_3 = { class: "justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpButton = _resolveComponent("LpButton")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_LpButton, {
        color: "red-lp-100",
        textColor: "white",
        title: "Ikuti laporan",
        textSize: 14,
        fontWeight: "semibold",
        isWidthFull: "",
        onClick: _ctx.followReport
      }, null, 8, ["onClick"])
    ])
  ]))
}